import brandmark from "@/assets/brandmark.png";
import "./Wordmark.css";

/** Brand lockup: the brandmark sits to the left of the "Arkitectly" wordmark
 *  (Syne, logo-only per the token system), matching the design reference. The
 *  image is decorative — the wordmark text carries the name. */
export function Wordmark({ subtitle }: { subtitle?: string }) {
  return (
    <span className="wordmark-lockup">
      <img className="wordmark-lockup__mark" src={brandmark} alt="" aria-hidden="true" />
      <span className="wordmark">Arkitectly</span>
      {subtitle ? <span className="wordmark-lockup__sub">{subtitle}</span> : null}
    </span>
  );
}
